import { useState, useEffect } from 'react';
import moment from 'moment';

/**
 * Custom hook for managing single date state
 * @param {Object} options - Configuration options
 * @param {string} options.defaultDate - Default date in YYYY-MM-DD format
 * @returns {Object} Single date state and handlers
 */
const useSingleDate = (options = {}) => {
  const { defaultDate } = options;

  const [singleDate, setSingleDate] = useState('');

  useEffect(() => {
    const today = defaultDate || moment().format('YYYY-MM-DD');
    setSingleDate(today);
  }, [defaultDate]);

  const handleSingleDateChange = (value) => {
    setSingleDate(value);
  };

  const getSingleDateTimestamp = () => {
    return singleDate ? moment(singleDate).startOf('day')._d.getTime() : null;
  };

  return {
    // Display value (YYYY-MM-DD format for input)
    singleDate,

    // Timestamp value for API calls
    singleDateTimestamp: getSingleDateTimestamp(),

    // Change handler
    handleSingleDateChange,

    // Utility function
    getSingleDateTimestamp,
  };
};

export default useSingleDate;
